import { PageRowsResponseDTO } from './page-response-dto';
import { UserApproverRoleDTO } from './user-approver-role-dto';

export interface ReadUserApproverRoleResponseDTO extends PageRowsResponseDTO<UserApproverRoleDTO> {
    userRoles?: UserApproverRoleDTO[];
}
